/*
// Rumble Video component for FW2 video sections
// By: jacobhokanson
*/
import React from 'react';
import Video from '../../FW/Models/File/Video';

class RumbleVideo extends React.Component {
    render() {
        let id = Video.getRumbleId(this.props.src);
        let src =
          'https://rumble.com/embed/' +
          id +
          '?pub=4&rel=0';
        if (this.props.autoplay) {
          src += '&autoplay=1';
        }
        let player = (
          <iframe
            width="100%"
            height={this.props.height || '100%'}
            src={src}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        );
        return player;
      }
}

export default RumbleVideo;
